import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingService } from './setting.service';
import { AdminAuthService } from '../admin-auth.service';
import { OpenAdminDialogYesOrNo } from '../admin-yes-or-no/admin-yes-or-no.component';
import { Router } from '@angular/router';
import * as constants from "../../constant";

@Component({
  selector: 'wl-setting',
  templateUrl: './setting.component.html',
  providers: [SettingService]
})
export class SettingComponent implements OnInit {

  passForm: UntypedFormGroup;
  memberId: any;
  currentPasswordString:string= "Enter Current Password";
  loading: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    private setting: SettingService,
    private adminAuth: AdminAuthService,
    private dialog: MatDialog,
  ) {
    this.passForm = this.fb.group({

      newpassword: ['',[ Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])[\S]{8,24}$/)]],
      confpassword: ['', Validators.required],
      oldPrd: ['', Validators.required]
    },{ validator: this.checkIfMatchingPasswords('newpassword', 'confpassword') }
    );
  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: UntypedFormGroup) => {
      let passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true })
      }
      else {
        console.log('password is correct')
        return passwordConfirmationInput.setErrors(null);

      }
    }
  }

  ngOnInit() {
    this.memberId = sessionStorage.getItem('wl-admin-id');
  }


  updatePassword(formDirective: FormGroupDirective) {
    this.loading = true;

    let value = {...this.passForm.value};
    let prd = this.passForm.value.newpassword;
    let getStaffId = sessionStorage.getItem('staffId');
    let oldPrd = this.passForm.value.oldPrd;

    value = {
      prd, staffId: getStaffId, oldPrd, type:"change"
    }

    this.adminAuth.setNewPassword(value).subscribe(res => {
      this.loading = false

      if (res.message && (res.message == 'Password Updated Successfully' || res.message == 'Password Deleted and Updated Successfully')) {
        const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
          disableClose: true,
          width: 'auto', height: 'auto',
          data: {
            content1: constants.PASSWORD_UPDATED_SUCCESSFULLY,
            button1Text: "OK",
          }
        });
        dialogRef.afterClosed().subscribe(res => {

          if (res == "yes") {
            this.passForm.reset();
            formDirective.resetForm(); 
          } else {

          }
        })
      }else
      if (res.message && res.message == 'Password Already exist') {
        const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
          disableClose: true,
          width: 'auto', height: 'auto',
          data: {
            content1: constants.PASSWORD_ALREADY_EXISTS,
            button1Text: "OK",
          }
        });
      }else
      if (res.message && res.message == constants.PASSWORD_PHRASE) {
        const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
          disableClose: true,
          width: 'auto', height: 'auto',
          data: {
            content1: constants.PASSWORD_PHRASE,
            button1Text: "OK",
          }
        });
      }else 
      if(res.message && res.message == 'Entered old password does not match'){
        const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
          disableClose: true,
          width: 'auto', height: 'auto',
          data: {
            content1: constants.PASSWORD_ENTERED_WRONG,
            button1Text: "OK",
          }
        });
        dialogRef.afterClosed().subscribe(res => {
          this.passForm.controls['oldPrd'].reset();
          this.currentPasswordString = "Re-enter Current Password"
        })
      }
    }

    )
  }
}
